import React, { useEffect, useState } from "react";
import config from "../../config/APIEndpoints";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useGetProfileQuery } from "../../store/profile/UserApiSlice";

import PortfolioDropdown from "./portfoliodropdown";

const UserIcon =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/profilevectro.svg";
const Logo =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/logo.svg";
const GripLine =
  "https://neuro-temp.s3.ap-south-1.amazonaws.com/images/icons/sidebar/griplinessidebar.svg";

export default function PortfolioNavbar({ colortheme }) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    window.innerWidth < 1000 ? true : false
  );
  const toggleSidebar = () => {
    setIsSidebarCollapsed((prevState) => !prevState);
  };
  const { data: profiledata, isLoading: profileLoading } = useGetProfileQuery();
  const location = useLocation();
  console.log(location.pathname, profiledata?.profile?.profile_pic);

  const navigate = useNavigate();

  const handleScrollToInnovations = () => {
    if (location.pathname !== "/" || location.pathname !== "/portfolio") {
      navigate("/portfolio");
    }
    setTimeout(() => {
      document.getElementById("innovations")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };
  const handleScrollToFeatures = () => {
    if (location.pathname !== "/" || location.pathname !== "/portfolio") {
      navigate("/portfolio");
    }
    setTimeout(() => {
      document.getElementById("features")?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };
  useEffect(() => {
    if (location.pathname == "/" && profiledata) {
      navigate("/dashboard");
    }
  }, [location, profiledata]);
  return (
    <>
      <PortfolioDropdown
        selected="Dashboard"
        isCollapsed={isSidebarCollapsed}
        onToggle={toggleSidebar}
      />
      <div className="portfolionavbar">
        <div className="portfolionavbarleft">
          <img src={Logo} alt="Logo" className="desktoponly" />
          <img
            src={GripLine}
            alt="GripLine"
            className="mobileonly"
            onClick={toggleSidebar}
          />
        </div>
        <div
          className={
            colortheme === "blue"
              ? "portfolionavbarcenter desktoponly portfolionavbarcenterblue"
              : "portfolionavbarcenter desktoponly"
          }
        >
          <ul>
            <li onClick={handleScrollToFeatures}>Features</li>
            <li onClick={handleScrollToInnovations}>Innovations</li>
            {/* <li>Company</li> */}
            <li onClick={() => navigate("/pricing")}>Pricing</li>
          </ul>
        </div>
        <div className="portfolionavbarright">
          {profiledata ? (
            <div
              className="profiledataimg"
              style={{
                cursor: "pointer",
                width: "80px",
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <img
                src={
                  profiledata?.profile?.profile_pic
                    ? `${config.getEndpoint()}${
                        profiledata?.profile?.profile_pic
                      }`
                    : UserIcon
                }
                style={{
                  width: "50px",
                  height: "50px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #ccc",
                }}
                alt="User"
                onClick={() => navigate("/dashboard")}
              />
            </div>
          ) : (
            <button onClick={() => navigate("/login")}>Sign In</button>
          )}
        </div>
      </div>
    </>
  );
}
